import Icon from 'veui/components/Icon'
import { IconEnvelope } from 'dls-icons-vue'

Icon.register('envelope', IconEnvelope)
